import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import AppErrorBoundary from "@/components/AppErrorBoundary";
import { AuthProvider } from "@/context/AuthContext";
import AuthorshipEstablishment from "@/components/AuthorshipEstablishment";
import { OnboardingProvider } from "@/onboarding/OnboardingProvider";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { GOOGLE_CLIENT_ID } from "@/components/GoogleSignInButton";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const withGoogle = (node) => (GOOGLE_CLIENT_ID ? <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>{node}</GoogleOAuthProvider> : node);

// Benign ResizeObserver notifications (fired by React Flow's NodeResizer) surface
// as an uncaught-error overlay in dev. They are safe to ignore — swallow only that
// specific message so the CRA overlay does not interrupt canvas interaction.
const RO_ERR = /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/;
window.addEventListener("error", (e) => {
  if (e.message && RO_ERR.test(e.message)) {
    e.stopImmediatePropagation();
    const overlay = document.getElementById("webpack-dev-server-client-overlay");
    if (overlay) overlay.style.display = "none";
  }
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AppErrorBoundary>
        {withGoogle(
          <AuthProvider>
            <OnboardingProvider>
              <App />
            </OnboardingProvider>
            <AuthorshipEstablishment />
          </AuthProvider>
        )}
      </AppErrorBoundary>
    </QueryClientProvider>
  </React.StrictMode>,
);
